
      var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArrowUp = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 8,
  viewBox: "0 0 12 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#arrow-up_e55840793d1c532a__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.544 6.74A.874.874 0 0 1 .24 6.673 1.063 1.063 0 0 1 .221 5.35l.081-.09 5.077-5A.87.87 0 0 1 6.53.18l.092.08 5.077 5a1.06 1.06 0 0 1 .062 1.413.873.873 0 0 1-1.213.146l-.091-.08-4.455-4.388L1.544 6.74Z",
  fill: "var(--theme-primary, #810ea9)"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "arrow-up_e55840793d1c532a__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "var(--theme-light, #f9f3fb)",
  d: "M0 0h12v8H0z"
})))));

      const __svgRaw = "<svg width=\"12\" height=\"8\" viewBox=\"0 0 12 8\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<g clip-path=\"url(#clip0_5118_7454)\">\r\n<path d=\"M1.544 6.73993C1.1668 7.11144 0.583 7.08132 0.2401 6.67267C-0.0765 6.29544 -0.0772 5.72754 0.2213 5.3502L0.3022 5.26005L5.37907 0.26006C5.70181 -0.0577901 6.18052 -0.0842823 6.52926 0.180596L6.62093 0.26006L11.6978 5.26005C12.0751 5.63156 12.1029 6.26401 11.7599 6.67267C11.4434 7.04989 10.9216 7.10457 10.5465 6.81855L10.456 6.73993L6.00092 2.351L1.544 6.73993Z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n</g>\r\n<defs>\r\n<clipPath id=\"clip0_5118_7454\">\r\n<rect width=\"12\" height=\"8\" fill=\"var(--theme-light, #f9f3fb)\"/>\r\n</clipPath>\r\n</defs>\r\n\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/arrow-up.e55840793d1c532ab9d0e92d506bd3a4.svg"),
        {
          React: SvgArrowUp,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      